import React from "react";
import { Doughnut } from "react-chartjs-2";


function Efficiency() {
  const data = {
    labels: ["Spend", "Earned"],
    datasets: [
      {
        label: "Population (millions)",
        backgroundColor: ["rgba(91,37,245, 1)", "#dad7e9"],
        data: [65, 35],
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          fontColor: "rgba(0,0,255, 0.5)",
          boxWidth: 15,
          font: {
            size: 9
        }
        },
      },
    },
  };
  return <Doughnut data={data} options={options} />;
}

export default Efficiency;
